export default "__VITE_ASSET__d470dcde__"